import React from 'react'
import DocumentAnalysisContext from '../../../contexts/DocumentAnalysisContext'
import StatusContext from '../../../contexts/StatusContext'
import AuthContext from '../../../contexts/AuthContext'
import {ResponseDisplay} from "../responsedisplay/ResponseDisplay"
import "./documentanalysis.css"

import { useEffect } from "react";
import {NavBarDocumentAnalysis} from '../navbardocumentanalysis/NavBarDocumentAnalysis'
import {PromptWithIcon} from '../promptwithicon/PromptWithIcon';
import { AlertDialog } from '../alertdialog/AlertDialog'

import Stack from '@mui/material/Stack'
import {PushButton} from '../pushbutton/PushButton'
import {AvailableCredits} from '../availablecredits/AvailableCredits'
import { WaitonResponse } from '../waitonresponse/WaitonResponse'
import FileUploader from '../FileUploader/FileUploader';
import { DialogProgress } from './DialogProgress';


export const DocumentAnalysis = () => {
    

    const alertYes = () => {
        console.log("AlertYes")
        onClearChat()
        closeDialogBox()
    }

    const alertCancel = () => {
        console.log("AlertCancel")
        closeDialogBox()
    }
    
    let {
        promptsandresponses, 
      
        onClearChat,
        confirmDelete, 
        changeConfirmDelete,
        onDeletePrompt,
        chatPrompt,
        setChatPrompt,
        onSubmitChat,
      
        status,
        onResubmitChat,
        
        getFileDetails,
        attachedFiles,
        removeFile,
    } = React.useContext(DocumentAnalysisContext);

    let {
        isMobile, 
        scrollRef,
     
        changeLanguage,

        openDialog,
        openDialogBox,
        closeDialogBox,

        onCopy,
        focusRef,

    } = React.useContext(StatusContext);

    let {
       checkCurrentUser
    } = React.useContext(AuthContext)

    useEffect(() => {
        console.log("DocumentAnalysis useEffect")

        if (checkCurrentUser())
            getFileDetails();
  
    }, [checkCurrentUser, getFileDetails])   
    
  return (

    <div className="homeContainer">
             
                <NavBarDocumentAnalysis title={changeLanguage('documentanalysis', 'navbartitle_2')}/>
              
                <div className="response-markdown" ref={scrollRef} >
                    {
                        Array.isArray(promptsandresponses) &&
                            promptsandresponses.map((item) => (
                                <ResponseDisplay key= {item.id} displayprompt = {item} displayicons = {confirmDelete[promptsandresponses.indexOf(item)].state}
                                changeConfirmDelete = {changeConfirmDelete} onDeletePrompt = {onDeletePrompt} onResubmitQuestion={onResubmitChat} onCopy={onCopy}/>
                             ))
                    }  
                </div> 

                {
                    (!status) &&
                        <WaitonResponse />
                }
                <hr className = 'separator'></hr>
        
                <PromptWithIcon prompt = {chatPrompt} setPrompt={setChatPrompt} onSubmit={onSubmitChat} placeholdertext={changeLanguage('assistant','promptplaceholder')}
                        attachedFiles={attachedFiles}
                        deleteFile={removeFile}/>

                {
                    (status) && <label className = 'statusLabel'>{status}</label>
                }
                
                <div ref={focusRef} className="mainButtons">
                 
                    <Stack direction="row" spacing={2}>         
                        <FileUploader style={{ cursor: 'pointer'}}/>        
                        <PushButton onClick={openDialogBox} label =  {changeLanguage('assistant','clearall')}/>
                    </Stack>
                  
                   <AvailableCredits />
                </div> 

                <label style={{ width: isMobile() ? '100%' : '50%' }}>{changeLanguage("documentanalysis", "note")}</label>
               
                <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={changeLanguage('dialog', 'cleardata')}/>

                <DialogProgress />
     </div>
  )
}


